// Utility functions for managing popup state

export const clearPopupSession = () => {
  sessionStorage.removeItem("vs_popup_closed_this_session");};

export const isPopupClosedThisSession = () => {
  return sessionStorage.getItem("vs_popup_closed_this_session") === "true";
};

export const setPopupClosedThisSession = () => {
  sessionStorage.setItem("vs_popup_closed_this_session", "true");};

// Clear popup cooldown for testing
export const clearPopupCooldown = () => {
  sessionStorage.removeItem("vs_popup_cooldown_at");};

// For testing - add to window object in development
if (process.env.NODE_ENV === "development") {
  window.clearPopupSession = clearPopupSession;
  window.isPopupClosedThisSession = isPopupClosedThisSession;
  window.setPopupClosedThisSession = setPopupClosedThisSession;
  window.clearPopupCooldown = clearPopupCooldown;
}
